import { Injectable } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map, tap, publishReplay, refCount } from 'rxjs/operators';
import { selectAssignmentGroups } from '../state/reducer';
import { LoadAssignmentGroups } from '../state/assignment-groups/actions';
import { AssignmentGroupsState } from '../state/assignment-groups/state';

@Injectable({
  providedIn: 'root'
})
export class AssignmentGroupsFacade {
  readonly groupState$: Observable<AssignmentGroupsState>;

  constructor(private store: Store<Record<string, unknown>>) {
    this.groupState$ = store.pipe(
      select(selectAssignmentGroups),
      map((groupsState) => {
        if (groupsState.error) {
          throw new Error(groupsState.error);
        } else {
          return groupsState;
        }
      }),
      tap((groupsState) => this.loadGroups(groupsState)),
      publishReplay(1),
      refCount()
    );
  }

  loadGroups(state: AssignmentGroupsState) {
    if (!state.error && !state.loading && !state.loaded) {
      setTimeout(() => {
        this.store.dispatch(new LoadAssignmentGroups());
      }, 1);
    }
  }
}
